// Validation untuk Login, Register dan Lupa Password

export const ValRate = async (data) => {
  const errors = [];

  if (Number(data.rating) === 0) {
    errors.push({
      type: "rating",
      message: "Rating tidak boleh kosong",
    });
  }

  if (
    data.description.length > 0 &&
    !/^[A-Za-z0-9 ]+$/.test(data.description)
  ) {
    errors.push({
      type: "description",
      message: "description hanya mengandung alphabet dan numeric",
    });
  }

  return errors;
};
